import type { ReactNode } from 'react';
import wizardForm from '@/styles/wizard.module.css';
import formStyles from './wizard-form.module.css';

export interface WizardFieldProps {
  label: string;
  required?: boolean;
  error?: string;
  hint?: string;
  testId?: string;
  errorTestId?: string;
  children: ReactNode;
}

export default function WizardField({
  label,
  required = false,
  error,
  hint,
  testId,
  errorTestId,
  children,
}: WizardFieldProps) {
  return (
    <div
      className={`${wizardForm.field} ${formStyles.field}`}
      data-testid={testId}
    >
      <span
        className={`${wizardForm.fieldLabel} ${required ? wizardForm.fieldLabelRequired : ''}`}
      >
        {label}
      </span>
      <div className={formStyles.control}>{children}</div>
      {error ? (
        <p
          className={wizardForm.fieldError}
          role="alert"
          data-testid={errorTestId}
        >
          {error}
        </p>
      ) : hint ? (
        <p className={wizardForm.fieldHint}>{hint}</p>
      ) : null}
    </div>
  );
}
